import { Address, VehicleId } from '../../sharedComponents/common.types';
import { ServiceType, ServiceOrderVehicleModel } from '../shared/commonServiceOrder.types';
import { AccessoryType, CollectedAccessories } from './accessory.types';

export enum ServiceOrderStatus {
    OPEN = 'open',
    COMPLETED = 'completed',
    CANCELLED = 'cancelled',
}

export type ServiceOrderPage = {
    readonly items: ServiceOrder[];
    readonly hasMore: boolean;
};

export type ServiceOrderVehicle = {
    readonly id: VehicleId;
    readonly requestedAccessories: AccessoryType[];
    readonly model?: ServiceOrderVehicleModel;
    readonly collectedAccessories?: CollectedAccessories;
};

export type Location = {
    readonly timeZone: string;
    readonly identifier?: string;
    readonly address?: Partial<Address>;
};

export type ServiceOrder = {
    readonly id: string;
    readonly externalOrderId: string;
    readonly vehicle: ServiceOrderVehicle;
    readonly status: ServiceOrderStatus;
    readonly type: ServiceType;
    readonly serviceLocation: Location;
    readonly startedAt?: Date;
    readonly completedAt?: Date;
    readonly orderIssuedAt: Date;
    readonly generalInformation?: string;
    readonly description?: string;
    readonly hasUnacknowledgedExternalChanges: boolean;
    readonly isFinalized: boolean;
    readonly isArchived: boolean;
    readonly externalOptionId?: string;
};
